import * as React from "react"

function CancelRound(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#343B45" />
      <path d="M8 8L16 16" stroke="#A7B5C8" stroke-width="1.5" />
      <path d="M16 8L8 16" stroke="#A7B5C8" stroke-width="1.5" />
    </svg>

  )
}

export default CancelRound
